<template>
  <div id="app">
    <router-view/>
    <!--全局语音-->
    <globalAudio></globalAudio>
  </div>
</template>

<script>
  import * as api from '@/api/base/base.js'
  import * as platformVersionsApi from '@/api/base/platformVersions.js'
  import StorageHelp from '@/utils/storageHelp'
  import {zhNoReloadPage} from '@/config/index.js'
  import { Dialog } from 'vant';
  import isElectron from 'is-electron'
  import globalAudio from '@/components/audio/globalAudio.vue'
  export default {
    name: 'App',
    components: {
      globalAudio
    },
    data(){
      return{
        timer: null
      }
    },
    mounted(){
      console.info("this.$router",this.$router)
      //  todo 暂时
      this.updateVersion();
      api.getPlatformConfig(true).then(resp=>{}).catch(err=> {});
      this.$store.dispatch("stompSocket/connect").then(resp=>{
         console.log("socket信息");
      });
      // 随机时间获取版本号并刷新页面，避免同一时间请求后台
      this.reloadVersion();

      // 全局获取banner
      this.$store.dispatch("baseInfo/getBannerList");

      // 全局获取公告
      this.$store.dispatch("baseInfo/getNotice");

    },
    methods:{
      reloadVersion() {
        let randomNum = this.getRandomTime(30,60) * 1000;
        console.log("randomNum",randomNum);
        this.timer = setTimeout(() => {
          this.checkVersionChange();
          this.timer = null;
          clearTimeout(this.timer);
          this.reloadVersion()
        },randomNum)
      },
      getRandomTime(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return parseInt(Math.floor(Math.random() * (max - min + 1)) + min, 10); //含最大值，含最小值
      },
      // 检测版本更新,且是否和本地版本一致，如果一致就自动更新
      checkVersionChange() {
        let params = {
          projectNameEnglish: 'fzk'
        };
        platformVersionsApi.getPlatformVersionsInfo(params).then(resp => {
           console.log('获取平台当前版本',resp);
           let VERSION = StorageHelp.getStorage(StorageHelp.VERSION);
           console.log("本地版本",VERSION)
           if((resp || []).length > 0 ){
              if(!VERSION ) {
                StorageHelp.setStorage(StorageHelp.VERSION,resp[0].version);
              }else if (VERSION && (VERSION !== resp[0].version)) {
                StorageHelp.setStorage(StorageHelp.VERSION,resp[0].version);
                if (this.isShouldReload()) {
                  window.location.reload();
                }
              }
           }
        }).finally(() => {})
      },
      isShouldReload() {
        let currentPage = this.$router.currentRoute.path;
        if(currentPage !== '/') {
          let findPath = currentPage.split('/')[1];
          if(zhNoReloadPage){
            let findPage = zhNoReloadPage.indexOf(findPath)
            if(findPage !== -1) return false;
            return true;
          } else {
            return true
          }
        }else {
          return true
        }

      },

      updateApp() {
        this.updateVersion();
      },
      autoUpdate () { // 用来触发更新函数
        console.log(this.ipcRenderer, '触发更新')
        this.ipcRenderer.send('checkForUpdateNow')
      },
      // todo  暂时  更新桌面应用版本
      updateVersion() {
        console.log("isElectron",isElectron())
        if(isElectron()) {
          this.ipcRenderer = window.ipcRenderer
          console.log("this.ipcRenderer",this.ipcRenderer,ipcRenderer)
          this.ipcRenderer.on('message', (event, data) => {
            console.log('监听更新消息', data.msg)
          })
          this.ipcRenderer.on('downloadProgress', (event, progressObj) => {
            console.log('获取下载进度', progressObj)
            // 可自定义下载渲染效果
          })
          this.ipcRenderer.on('isUpdateNow', (event, versionInfo) => {
            // 自定义选择效果，效果自行编写
            console.log("现在更新",event,versionInfo)
            let newVersion = ''
            if(versionInfo) {
              newVersion = versionInfo.version
            }
            Dialog.confirm({
              title: '标题',
              message: '弹窗内容',
            })
              .then(() => {
                console.log("点击现在更新")
                this.ipcRenderer.send('updateNow')
              })
              .catch(() => {
                // on cancel
              });
          });
          // electron应用启动后主动触发检查更新函数
          this.autoUpdate()
        }
      }
    },
    beforeDestroy () {
      // 移除ipcRenderer所有事件
      console.log("窗口销毁调用")
      if (isElectron()) {
        this.ipcRenderer.removeAllListeners()
      }
    },
  }
</script>

<style scoped>
  #app {
    padding: 0;
    margin: 0;
    height:100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue